
import * as THREE from 'three'
import EventEmitter from "./EventEmitter.js"
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import { gsap } from 'gsap'
import { FontLoader } from 'three/addons/loaders/FontLoader.js';

import Experience from "../Experience.js"

export default class Resources extends EventEmitter {
    constructor(sources) {
        super()

        //Options 
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.sources = sources

        //Setup
        this.items = {}
        this.toLoad = this.sources.length
        this.loaded = 0

        this.colorOverlay = localStorage["theme-preference"] === 'light' ? new THREE.Vector3(0.847, 0.867, 0.631) : new THREE.Vector3(0.145, 0.161, 0.)

        this.setLoaders()
        this.startLoading()

        /**
        * Overlay
        */

        this.overlayGeometry = new THREE.PlaneGeometry(2, 2, 1, 1)
        this.overlayMaterial = new THREE.ShaderMaterial({
            transparent: true,
            uniforms:
            {
                uStrength: { value: 0 },
                uColor: { value: this.colorOverlay }
            },
            vertexShader: `
                varying vec2 vUv;

                void main()
                {
                    gl_Position = vec4(position, 1.0);

                    vUv = uv;
                }
            `,
            fragmentShader: `
                uniform float uStrength;
                uniform vec3 uColor;

                varying vec2 vUv;

                
                void main()
                {
                vec2 vawedUv = vec2(vUv.x, vUv.y + sin(vUv.x * 20.0) * 0.01);
                float strength = step(uStrength, distance(vawedUv, vec2(0.5)));
                float strengthNegatif = 1.0 -  step(uStrength, distance(vawedUv, vec2(0.5)));

                // Color Version
                vec3 blackColor = vec3(0.0);
                vec3 uvColor = uColor;
            
                float mixedStrength = mix(strength, strengthNegatif, 0.);
                
                gl_FragColor = vec4(uvColor, mixedStrength);
                }
            `
        })
        const overlay = new THREE.Mesh(this.overlayGeometry, this.overlayMaterial)
        this.scene.add(overlay)
    }



    setLoaders () {
        this.loaders = {}

        this.loaders.dracoLoader = new DRACOLoader()
        // this.loaders.dracoLoader.setDecoderPath('/draco/')
        this.loaders.dracoLoader.setDecoderPath('https://www.gstatic.com/draco/versioned/decoders/1.5.6/')

        this.loaders.gltfLoader = new GLTFLoader()
        this.loaders.gltfLoader.setDRACOLoader(this.loaders.dracoLoader)

        this.loaders.textureLoader = new THREE.TextureLoader()
        this.loaders.cubeTextureLoader = new THREE.CubeTextureLoader()
        this.loaders.fontLoader = new FontLoader();

    }

    startLoading () {
        //Load each source
        for (const source of this.sources) {
            if (source.type === 'gltfModel') {
                this.loaders.gltfLoader.load(
                    source.path,
                    (file) => {
                        this.sourceLoaded(source, file)
                    }
                )
            } else if (source.type === 'texture') {
                this.loaders.textureLoader.load(
                    source.path,
                    (file) => {
                        this.sourceLoaded(source, file)
                    }
                )
            } else if (source.type === 'cubeTexture') {
                this.loaders.cubeTextureLoader.load(
                    source.path,
                    (file) => {
                        this.sourceLoaded(source, file)
                    }
                )
            } else if (source.type === 'font') {
                this.loaders.fontLoader.load(
                    source.path,
                    (file) => {
                        this.sourceLoaded(source, file)
                    }
                )
            }
        }
    }

    sourceLoaded (source, file) {
        this.items[source.name] = file

        this.loaded++

        const loadingBarElement = document.querySelector('.loading-bar')
        const holderBarElement = document.querySelector('.loading-holder')
        const titleElement = document.querySelector('.app-name')
        const mainElement = document.querySelector('main')

        const progressRatio = this.loaded / this.toLoad
        loadingBarElement.style.transform = `translateX(${(progressRatio * 100) - 100}% )`

        if (this.loaded === this.toLoad) {
            this.trigger('ready')

            gsap.delayedCall(.1, () => {
                gsap.to(this.overlayMaterial.uniforms.uStrength, { duration: 1.5, value: 1, ease: 'power2.in' })
                holderBarElement.classList.add('ended')
                //titleElement.classList.add('ended')
            })
            gsap.delayedCall(2, () => {
                mainElement.classList.remove('-hide')

            })
            gsap.delayedCall(.9, () => {
                titleElement.classList.add('ended')
            })
        }
    }
}

